export const isRequesterAndLoggedIn = (
  isLoggedIn: boolean,
  contactDetailsIndex: number,
): boolean => {
  return isLoggedIn && contactDetailsIndex === 0;
};
